import { FACTURE_SOUS_TYPE, FACTURE_ETAT } from '@/configuration/facture/factureConf';
import gestionDateBase from '@/services/general/gestionDateBase';
import trierIntervenants from '@/services/devisCommandes/trierIntervenants';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';

export default function formatListeFactures(factures) {
  factures.forEach((facture) => {
    facture.selected = false;
    facture.dateDevisCommande = gestionDateBase(facture.dateDevisCommande);
    const etat = FACTURE_ETAT.find((el) => {
      return el.code === facture.etat;
    });
    if (etat) {
      facture.etatLibelle = etat.libelle;
    }
    facture.annonceurs = [];
    facture.intervenants.forEach((inter) => {
      if (inter.payeur) {
        facture.payeurLibelle = inter.nomCommercial;
        facture.payeurId = inter.tiersId;
        facture.domTom = inter.tiers.domTom;
      }
      if (inter.annonceur) {
        facture.annonceurs.push(inter);
      }
    });
    if (facture.commercial) {
      facture.nomCommercial = nomPrenomGetter(facture.commercial);
    }
    if (facture.tiersFactorId) {
      facture.tiersFactorLibelle = facture.tiersFactor ? facture.tiersFactor.nomCommercial : '';
    }

    const sousType = FACTURE_SOUS_TYPE.find((el) => {
      return el.code === facture.sousType;
    });
    if (sousType) {
      facture.sousTypeLibelle = sousType.libelle;
    }

    let listeIntervenants = '';
    trierIntervenants(facture);
    listeIntervenants = facture.intervenants.map((el) => el.nomCommercial).join(', ');
    facture.listeIntervenants = listeIntervenants;
  });
}
